{
  "738352202400": "WW-30 Terano",
  "738353202400": "W-30 Terano",
  "738552202400": "WW-50 Terano",
  "738553202400": "W-50 Terano",
  "738673202400": "W-40 TM",
  "738674202400": "WW-40 TM",
  "738675202400": "C-40 TM",
  "738792202400": "WW-70 Terano",
  "738793202400": "W-70 Terano",
  "738821202400": "WW-50 TM",
  "738822202400": "W-50 TM",
  "738961202400": "WW-70 TM",
  "738962202400": "W-70 TM",
  "738965202400": "C-70 TM",
  "738992202400": "WW-90 Terano",
  "738993202400": "W-90 Terano",
  "739753202400": "W-10 TM",
  "739754202400": "WW-10 TM"
}
